'use client';

import React, { memo } from 'react';
import AIMakerLogo from './AIMakerLogo';

interface AppLogoProps {
  src?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
  variant?: 'color' | 'white' | 'black';
  showText?: boolean;
}

const AppLogo = memo(function AppLogo({
  size = 115,
  className = '',
  onClick,
  variant = 'color',
  showText = false,
}: AppLogoProps) {
  return (
    <div
      className={`flex items-center ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''} ${className}`}
      onClick={onClick}
    >
      <AIMakerLogo size={size} variant={variant} showText={showText} />
    </div>
  );
});

export default AppLogo;
